import { useNavigate } from 'react-router-dom';
import { Anchor, Breadcrumbs, Container, Divider, Group, Tabs } from '@mantine/core';
import { useContext } from 'react';
import { DndProvider } from 'react-dnd-latest';
import { HTML5Backend } from 'react-dnd-html5-backend-latest';
import { IconFileInvoice, IconHash, IconSettings } from '@tabler/icons';
import { DocumentTemplateContext } from '../../../Service/Context/DocumentTemplateContext';
import BookitupAlert from '../../../Atoms/BookitupAlert';
import DocumentLanguagePicker from '../../../Atoms/inputs/DocumentLanguagePicker';
import DocumentTemplateActions from './DocumentTemplateActions';
import DocumentTemplateSkeleton from './DocumentTemplateSkeletonV2';
import DistancePolicySettings from './DistancePolicySettings';

const DocumentTemplateEditor = () => {
  const navigate = useNavigate();
  const { loading, bookitupDocument, savePatch } = useContext(DocumentTemplateContext);
  const { name, documentType, language } = bookitupDocument ?? {};

  return (
    <Container p={0}>
      <Group position="apart">
        <Breadcrumbs>
          <Anchor onClick={() => navigate('/settings/templates')}>Vorlagen</Anchor>
          <Anchor sx={{ pointerEvents: 'none' }}>
            <b>{loading ? 'Laden ...' : name || 'Nicht gefunden '}</b>
          </Anchor>
        </Breadcrumbs>
        <Group>
          <DocumentTemplateActions />
        </Group>
      </Group>
      <Divider my="sm" />
      <BookitupAlert mb="md" title="Tipp: Platzhalter" icon={<IconHash />}>
        Du kannst Platzhalter einfügen, indem du die Raute-Taste (#) drückst.
      </BookitupAlert>

      <Tabs defaultValue="content">
        <Tabs.List>
          <Tabs.Tab value="content" icon={<IconFileInvoice size={14} />}>
            Inhalt
          </Tabs.Tab>
          <Tabs.Tab value="settings" icon={<IconSettings size={14} />}>
            Einstellungen
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="content" pt="xl">
          <DndProvider backend={HTML5Backend}>
            <DocumentTemplateSkeleton />
          </DndProvider>
        </Tabs.Panel>
        <Tabs.Panel value="settings" pt="xl">
          <DocumentLanguagePicker
            variant="select"
            language={language}
            onLanguageChange={bookitupDocument ? (newLanguage) => savePatch({ language: newLanguage }) : undefined}
          />
          {documentType !== 'REMINDER' && documentType !== 'CANCEL' && documentType !== 'CREDIT_NOTE' && (
            <>
              <Divider my="xl" label="Fahrtkosten" labelPosition="left" />
              <DistancePolicySettings />
            </>
          )}
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default DocumentTemplateEditor;
